import { useShowSearchMetaTooltip } from 'shared/hooks';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAnalytics, useDatesChangeHandler } from './hooks';
import { selectDatesFilter } from 'shared/selectors/filters';
import { DropdownDates, DropdownFilter, useDropdown } from 'shared/components/DropdownFilter';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { FILTER_KEY } from './constants';
import { trackCloseDatesModal, trackOpenDatesModal } from './tracking';

export const DatesContainer: FC = () => {
  const { config } = useApplicationContext();

  const {
    label,
    value: { from, to },
    min,
    max,
  } = useSelector(selectDatesFilter);

  const onChange = useDatesChangeHandler();

  const { opened, onClose, onOpen } = useDropdown(FILTER_KEY);

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const handleOpen = useCallback(() => {
    onOpen();
    trackOpenDatesModal();
  }, [onOpen]);

  const handleClose = useCallback(() => {
    onClose();
    trackCloseDatesModal();
  }, [onClose]);

  useAnalytics();

  const isFiltersRedesignEnabled = config.get<boolean>('BX.FilterRedesign.Enabled') || false;

  return (
    <DropdownFilter
      opened={opened}
      onOpen={handleOpen}
      onClose={handleClose}
      showTooltip={showTooltip}
      buttonLabel={label}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={<DropdownDates valueTo={to} valueFrom={from} max={max} min={min} onChange={onChange} />}
    />
  );
};
